import ClassModel from "#src/models/ClassModel.ts";
import GroupRegistrationModel from "#src/models/GroupRegistrationModel.ts";
import { MembershipStatus } from "#types/code-generator.ts";

interface CalculateMembershipRegistrationPriceInput {
  offering: ClassModel;
  user: {
    id: string;
    memberships: {
      offering?: {
        id: string;
      };
      offeringId?: string;
      status: MembershipStatus;
      roster?: {
        id: string;
      }[];
    }[];
  };
  registration?: GroupRegistrationModel;
}

export function calculateMembershipRegistrationPrice({
  offering,
  user,
  registration,
}: CalculateMembershipRegistrationPriceInput) {
  let membershipPrice = offering.price;
  let applicableUserMemberships = offering.membershipPrices?.filter((m) =>
    user?.memberships?.find(
      (um) =>
        um.status === MembershipStatus.Active &&
        (um.offeringId === m.membershipOfferingId ||
          um.offering?.id === m.membershipOfferingId)
    )
  );

  if (registration) {
    applicableUserMemberships =
      offering.membershipPrices?.filter((m) =>
        user?.memberships?.find((um) => {
          const isActive = um.status === MembershipStatus.Active;
          const isMatchingMembership =
            (um.offeringId &&
              (um.offeringId === m.membershipOfferingId ||
                um.offeringId === m.membershipOffering?.id)) ||
            (um.offering?.id &&
              (um.offering?.id === m.membershipOfferingId ||
                um.offering?.id === m.membershipOffering?.id));
          const isInRoster = um.roster?.find(
            (s) =>
              s.id === registration.student?.id ||
              registration.roster?.find((rs) => rs.id === s.id)
          );

          return isActive && isMatchingMembership && isInRoster;
        })
      ) || [];
  }

  const applicableUserMembershipsIds = applicableUserMemberships.map(
    (m) => m.membershipOfferingId || m.membershipOffering?.id
  );

  if (applicableUserMemberships.length > 0) {
    for (const mp of offering.membershipPrices) {
      if (applicableUserMembershipsIds.includes(mp.membershipOfferingId)) {
        if (membershipPrice > mp.price) {
          membershipPrice = mp.price;
        }
      }
    }
  }

  return membershipPrice;
}
